import React, { Suspense, lazy } from 'react';
import { StatsBar } from './StatsBar';
import { Testimonials1 } from './Testimonials1';
import { PainPointsSection } from './PainPointsSection';
import { TomosSection } from './TomosSection';
import { BonusesSection } from './BonusesSection';
import { PricingSection } from './PricingSection';
import { MasterPackSection } from './MasterPackSection';
import { GuaranteeSection } from './GuaranteeSection';
import { FaqSection } from './FaqSection';
import { CostComparisonSection } from './CostComparisonSection';
import { FinalCtaSection } from './FinalCtaSection';
import { Footer } from './Footer';
import { SocialProofPopup } from './SocialProofPopup';
export function BelowFold() {
  return <>
      <StatsBar data-id="element-6" />
      <Testimonials1 data-id="element-7" />
      <PainPointsSection data-id="element-8" />
      <TomosSection data-id="element-9" />
      <BonusesSection data-id="element-10" />
      <PricingSection data-id="element-11" />
      <MasterPackSection data-id="element-12" />
      <GuaranteeSection data-id="element-13" />
      <FaqSection data-id="element-14" />
      <CostComparisonSection data-id="element-15" />
      <FinalCtaSection data-id="element-16" />
      <Footer data-id="element-17" />
      <SocialProofPopup data-id="element-18" />
    </>;
}